const LOAD_DATA_MASTER_BENEFIT           = 'LOAD_DATA_MASTER_BENEFIT'
const LOAD_DATA_MASTER_BENEFIT_SUCCESS   = 'LOAD_DATA_MASTER_BENEFIT_SUCCESS'
const LOAD_DATA_MASTER_BENEFIT_FAILED    = 'LOAD_DATA_MASTER_BENEFIT_FAILED'
const UNMOUNT_DATA_MASTER_BENEFIT        = 'UNMOUNT_DATA_MASTER_BENEFIT'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const masterBenefitReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_MASTER_BENEFIT:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_MASTER_BENEFIT_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_MASTER_BENEFIT_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_MASTER_BENEFIT:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default masterBenefitReducer;